export default [
    'POTVRZENI_ZADOSTI',
    'SOUHLAS_S_PODMINKAMI',
    'ZAPLACENI_POPLATKU_KARTOU',
    'POSKYTNUTI_RC',
    'STAZENI_VYPISU_A_FAKTURY'
];
